import { useEffect } from 'react';
import heroImage from '../assets/images//Hand coding-pana.svg';
//import './test';
import {TxtType} from '../assets/js/typewrite';

export default function HeroSection(){
    useEffect(()=>{
        var element = document.getElementsByClassName('type-write')[0];
        let expertise = [
            'Software Engineer','Backend Engineer', 'Desktop Engineer'
        ];

        new TxtType(element, expertise, 2000)
    })
    return(
        <section className='section hero bg-light'>
            <div className="container">
                <div className="row flex-lg-row-reverse  g-2">
                    <div className="row flex-lg-row-reverse align-items-center g-5">
                        <div className="col-10 col-sm-8 col-lg-6">
                            <img src={heroImage} className="d-block mx-lg-auto img-fluid"  width="500" height="500"  alt="hero_image"/>
                        </div>

                        <div className="col-lg-6">
                            <div className="hero-content">
                                <div className="hero-text mb-5">
                                    <p className='h5'>I'm</p>
                                    <h1 className='display-4'>Moses Quayson</h1>
                                    <h4 className='type-write'>{''}</h4>
                                    
                                </div>

                                <div className="hero-buttons mb-5">
                                    <a href='/#' className='btn btn-warning shadow-sm'>
                                        My Resume
                                    </a>
                                    <a className='btn btn-primary shadow-sm' href='#projects'>My Works</a>
                                </div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
        </section>
    )
}